import { City } from 'core/entities/geo';

export const cityName = (city: City) => {
  let result = '';
  if (city.namePrepPrep) {
    result = city.namePrepPrep;
  } else if (city.namePrep) {
    result = `в ${city.namePrep}`;
  }
  if (result.length < 3) {
    result = `в ${city.name || city.slug}`;
  }
  return result;
};
